import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderCustomer extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        phone_number: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    };

    render() {
        const { t, name, phone_number } = this.props;
        return (
            <div className="m2g-order-confirmation-customer">
                <label className="m2g-order-confirmation-label m2g-text--offset m2g-text--small">
                    {t('for')}&nbsp;
                </label>
                <span className="m2g-order-confirmation-customer-name">
                    {name}
                </span>
                &nbsp;
                <span className="m2g-order-confirmation-customer-phone-number m2g-text--offset">
                    {phone_number}
                </span>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(OrderCustomer);
